import React, { Component } from 'react';
import * as $ from 'jquery';
import axios from 'axios';
import { compose } from 'recompose';
import { Trans, translate } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { validateCard } from '../../../helpers/card';
import TypeOfCard from '../../../components/TypeOfCard';
import GoBackButton from '../../../components/GoBackButton';
import SuccessDialogPayment from '../../../components/SuccessDialogPayment';
import Dialog from '../../../components/Dialog';
import Input from '../../../components/Input';

let cancelToken;

class CardCoworkConatiner extends Component {
    constructor(props) {
        super(props);
        this.state = {
            estados: "",
            center_info: null,
            // cardCvc: "",
            // cardDate: "",
            cardName: "",
            // cardNumber: "",
            street: "",
            neighborhood: "",
            country: "",
            city: "",
            po: "",
            is_factura: false,
            duracion_str: "",
            precio: null,
            isPaying: null,
            cnumber: "",
            cmonth: '',
            cyear: '',
            cvc: '',
            error: null,
            success: false,
            showModalInvalidNumber: false,
            fieldsValid: {}
        };
        this.handleCardNumber = this.handleCardNumber.bind(this);
    }

    componentDidMount() {
        cancelToken = axios.CancelToken.source();
        if (this.props.match.params.coworkid) {
            this.setState({ centro_id: this.props.match.params.coworkid })
            this.getCenter({
                token_id: this.props.getTokenId(),
                center_id: this.props.match.params.coworkid
            });
        }
        if (this.props.location.state) {
            if (this.props.location.state.duracion_str) {
                this.setState({
                    duracion_str: this.props.location.state.duracion_str,
                    precio: this.props.location.state.precio,
                    lastname: this.props.location.state.lastname,
                    name: this.props.location.state.name,
                    email: this.props.location.state.email,
                    phone: this.props.location.state.phone,
                    center_id: this.props.match.params.coworkid,
                    duracion_id: this.props.match.params.duracionid,
                    new_date: this.props.location.state.new_date
                })
            }
        }

        // Se valida que exista el estado del pago 1
        if (!this.props.location.state) {
            this.props.history.goBack();
            return null
        }
        // Se valida que tenga todos los parametros correctos
        const keys = Object.keys(this.props.location.state);
        // Son 8 parametros, si no tiene 8 se regresa
        if (keys.length < 8) {
            this.props.history.goBack();
            return null
        }
    }

    componentWillUnmount() {
        cancelToken.cancel('Component will unmount.');
    }


    handlePaymentCoworkConekta = (params) => {
        const onSuccess = (token) => this.payCowork(
            Object.assign({},
                params,
                { token_conekta: token.id })
        );

        const onError = (error) => this.setState({
            error: error.message_to_purchaser,
            isPaying: false
        });

        window.Conekta.setPublicKey(this.state.center_info.c_key)
        window.Conekta.Token.create(
            this.getTokenParams(),
            (token) => onSuccess(token),
            (error) => onError(error)
        );
    }

    getCenter = (params) => {
        this.props.post(
            "/getCentersByCity",
            params,
            (response) => this.didGetCenter(response),
            (error) => this.handleErrorResponse(error),
            cancelToken
        );
    }

    getTokenParams = () => {
        const number = this.state.cnumber.replace(/\s/g, '');
        return {
            "card": {
                "name": this.state.cardName.trim(),
                number,
                "exp_year": "20" + this.state.cyear.trim(),
                "exp_month": this.state.cmonth.trim(),
                "cvc": this.state.cvc.trim(),
                "address": {
                    "street1": this.state.street.trim(),
                    "street2": this.state.neighborhood.trim(),
                    "city": this.state.city.trim(),
                    "state": this.state.estados.trim(),
                    "zip": this.state.po.trim(),
                    "country": this.state.country.trim()
                }
            }
        }
    }

    payCowork = (params) => {
        this.props.post(
            "/payCowork",
            params,
            () => this.setState({ success: true }),
            (error, _, conekta_msj, msg) => {
                this.setState({ isPaying: false });
            },
            cancelToken,
            ({ data }) => this.setState({ isPaying: false, error: data.msg })
        );
    }

    didGetCenter = (response) => {
        this.setState({ center_info: response });
    }

    handleErrorResponse = (response) => {
        console.warn("Error en la petición")
    }

    handleCardName = (event) => {
        this.setState({ cardName: event.target.value });
    }

    handleCardMonth = (event) => {
        this.setState({ cmonth: event.target.value });
    }


    handleCardNumber = (e) => {
        let value = e.target.value
        const { isValid, newValue } = validateCard({ value, state: this.state.cnumber })
        if (isValid) {
            this.setState({ cnumber: newValue });
        }
    }

    handleCardYear = (event) => {
        this.setState({ cyear: event.target.value });
    }

    handleCardCvc = (event) => {
        this.setState({ cvc: event.target.value });
    }
    handleStreetChange = (event) => {
        this.setState({ street: event.target.value });
    }

    handleNeighborhoodChange = (event) => {
        this.setState({ neighborhood: event.target.value });
    }

    handlePoChange = (event) => {
        this.setState({ po: event.target.value });
    }

    handleCityChange = (event) => {
        this.setState({ city: event.target.value });
    }

    handleChangeEstados = (event) => {
        this.setState({ estados: event.target.value });
    }

    handleCountryChange = (event) => {
        this.setState({ country: event.target.value });
    }

    handleFacturaChange = (event) => {
        if (this.state.is_factura) {
            this.setState({ is_factura: false });
        } else {
            this.setState({ is_factura: true });
            $('#btnFacturas').click()
        }
    }

    handlePaymentSubmit = (event) => {
        event.preventDefault();
        if (this.state.phone.length !== 10) {
            this.setState({ showModalInvalidNumber: true })
            return null
        }

        const isValid = Object.values(this.state.fieldsValid).every(value => value);
        if (!isValid) return alert('Favor de llenar todos los campos correctamente');
        // const cnumber = this.state.cnumber.replace(/\s/g, '');

        const params = {
            name: this.state.name,
            lastname: this.state.lastname,
            phone: this.state.phone,
            email: this.state.email,

            duracion_id: this.state.duracion_id,
            _isInvoice: this.state.is_factura,
            center: this.state.center_id,

            token_id: this.props.getTokenId(),
            token_session: this.props.getTokenSession(),

            // fecha de inicio
            start_date: this.state.new_date
        };
        // console.log(params)
        const callback = () => { this.handlePaymentCoworkConekta(params); }
        this.setState({ isPaying: true }, callback);

    }

    handleValidate = ({ name, isValid }) => {
        this.setState({
            fieldsValid: {
                ...this.state.fieldsValid,
                [name]: isValid
            }
        })
    }

    render() {
        // Correo de facturación de domicilio comercial: ventasenlinea@iosoffices.com
        const email_facturacion = this.state.center_info ? this.state.center_info.email_facturacion : null;
        const { t } = this.props;
        const currency = 'MXN'

        return (
            <React.Fragment >
                {this.state.success &&
                    <SuccessDialogPayment centerName={this.state.center_info.name} />
                }
                {
                    this.state.showModalInvalidNumber &&
                    <Dialog
                        title={t('venta_linea.modal.title_invalid_number')}
                        handleDismiss={() => this.setState({ showModalInvalidNumber: false })}
                    >
                        {t('venta_linea.modal.description_invalid_number')}
                    </Dialog>
                }
                <div className='content-resvations container-payment'>
                    <div className="container-resvations-title">
                        <GoBackButton isPayment ignoreModal />
                        <h2 className="page-header-card ">
                            <span>{t('dashboard.room_payment.heading_payment')}</span>
                        </h2>
                    </div>
                    <div className="col-sm-12 col-md-6 col-lg-6 container-fluid-info-mas full-height">
                        <img
                            src={`https://api.iosoffices.com/apiosfera/v4/src/uploads/cowork_imagenes/${this.state.centro_id}`}
                            alt="Fondo de la imagen"
                            className="background-img"
                        />
                        <div className="panel-resvations container-forms flex-center">
                            <div className="card-info-card">
                                <h2 className="page-header-text">
                                    {this.state.center_info ? this.state.center_info.name : null}
                                </h2>
                                <p className="page-content-text">
                                    {this.state.center_info
                                        ? this.state.center_info.direccion + ", " + this.state.center_info.ciudad
                                        + ", " + this.state.center_info.estado + ", " + this.state.center_info.cp
                                        : null}
                                </p>
                                <div className="form-group">
                                    <div className="input-group input-lg-xl">
                                        <div className="form-group info-payment">
                                            <p>
                                                <Trans>dashboard.room_payment.period</Trans> {this.state.duracion_str ? this.state.duracion_str : null}
                                            </p>
                                            <p>
                                                <Trans>dashboard.room_payment.subtotal</Trans> {this.state.precio} {currency}
                                            </p>
                                            <p>
                                                <Trans>dashboard.room_payment.iva</Trans> {(this.state.precio * .16)} {currency}
                                            </p>
                                            <p>
                                                <Trans>dashboard.room_payment.total</Trans> {Math.ceil(this.state.precio * 1.16)} {currency}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-12 col-md-6 col-lg-6 container-fluid-info-mas" >

                        <form method="post" onSubmit={this.handlePaymentSubmit}>
                            <fieldset>
                                <div className="panel-resvations container-forms">
                                    <div className="forms-card">
                                        <div className="col-xs-12">
                                            <div className="form-group">
                                                <Input
                                                    className="form-control"
                                                    onChange={this.handleCardName}
                                                    placeholder={t('dashboard.room_payment.holder_cname')}
                                                    required={true}
                                                    type="text"
                                                    name="cardName"
                                                    onValidate={this.handleValidate}
                                                    value={this.state.cardName} />
                                            </div>
                                        </div>
                                        <div className="col-xs-12">
                                            <div className="form-group">
                                                <Input
                                                    className="form-control"
                                                    maxLength="19"
                                                    onChange={this.handleCardNumber}
                                                    placeholder={t('dashboard.room_payment.holder_cnumber')}
                                                    required={true}
                                                    type="text"
                                                    name="cnumber"
                                                    onValidate={this.handleValidate}
                                                    value={this.state.cnumber} />
                                                <TypeOfCard number={this.state.cnumber} />
                                            </div>
                                        </div>
                                        <div className="col-xs-4">
                                            <div className="form-group">
                                                <Input
                                                    className="form-control"
                                                    max="12"
                                                    min="1"
                                                    onChange={this.handleCardMonth}
                                                    placeholder={t('dashboard.room_payment.holder_cmonth')}
                                                    required={true}
                                                    type="number"
                                                    name="cmonth"
                                                    onValidate={this.handleValidate}
                                                    value={this.state.cmonth} />
                                            </div>
                                        </div>
                                        <div className="col-xs-4">
                                            <div className="form-group">
                                                <Input
                                                    className="form-control"
                                                    max="99"
                                                    min="19"
                                                    onChange={this.handleCardYear}
                                                    placeholder={t('dashboard.room_payment.holder_cyear')}
                                                    required={true}
                                                    type="number"
                                                    name="cyear"
                                                    onValidate={this.handleValidate}
                                                    value={this.state.cyear} />
                                            </div>
                                        </div>
                                        <div className="col-xs-4">
                                            <div className="form-group">
                                                <Input
                                                    className="form-control"
                                                    maxLength="4"
                                                    onChange={this.handleCardCvc}
                                                    placeholder={t('dashboard.room_payment.holder_cvc')}
                                                    required={true}
                                                    type="number"
                                                    name="cvc"
                                                    onValidate={this.handleValidate}
                                                    value={this.state.cvc} />
                                            </div>
                                        </div>
                                        <div className="col-xs-12">
                                            <p>
                                                <small className="text-muted">
                                                    {t('dashboard.room_payment.security')}
                                                </small>
                                            </p>
                                        </div>
                                        <div className="col-xs-12">
                                            <div className="form-group">
                                                <Input
                                                    className="form-control"
                                                    onChange={this.handleStreetChange}
                                                    placeholder={t('dashboard.room_payment.holder_street')}
                                                    required={true}
                                                    type="text"
                                                    name="street"
                                                    onValidate={this.handleValidate}
                                                    value={this.state.street} />
                                            </div>
                                        </div>
                                        <div className="col-xs-12 col-sm-8">
                                            <div className="form-group">
                                                <Input
                                                    className="form-control"
                                                    onChange={this.handleNeighborhoodChange}
                                                    placeholder={t('dashboard.room_payment.holder_neighborhood')}
                                                    required={true}
                                                    type="text"
                                                    name="neighborhood"
                                                    onValidate={this.handleValidate}
                                                    value={this.state.neighborhood} />
                                            </div>
                                        </div>
                                        <div className="col-xs-12 col-sm-4">
                                            <div className="form-group">
                                                <Input
                                                    className="form-control"
                                                    onChange={this.handlePoChange}
                                                    placeholder={t('dashboard.room_payment.holder_po')}
                                                    required={true}
                                                    type="number"
                                                    name="po"
                                                    onValidate={this.handleValidate}
                                                    value={this.state.po} />
                                            </div>
                                        </div>
                                        <div className="col-xs-12 col-sm-8">
                                            <div className="form-group">
                                                <Input
                                                    className="form-control"
                                                    onChange={this.handleCityChange}
                                                    placeholder={t('dashboard.room_payment.holder_city')}
                                                    required={true}
                                                    type="text"
                                                    name="city"
                                                    onValidate={this.handleValidate}
                                                    value={this.state.city} />
                                            </div>
                                        </div>
                                        <div className="col-xs-12 col-sm-4">
                                            <div className="form-group">
                                                <Input
                                                    className="form-control"
                                                    onChange={this.handleChangeEstados}
                                                    placeholder={t('dashboard.room_payment.holder_state')}
                                                    required={true}
                                                    type="text"
                                                    name="estados"
                                                    onValidate={this.handleValidate}
                                                    value={this.state.states} />
                                            </div>
                                        </div>
                                        <div className="col-xs-12 col-sm-4">
                                            <div className="form-group">
                                                <Input
                                                    className="form-control"
                                                    onChange={this.handleCountryChange}
                                                    placeholder={t('dashboard.room_payment.holder_country')}
                                                    required={true}
                                                    type="text"
                                                    name="country"
                                                    onValidate={this.handleValidate}
                                                    value={this.state.country} />
                                            </div>
                                        </div>
                                        <div className="col-xs-12">
                                            <div className="form-group">
                                                <div className="checkbox">
                                                    <label>
                                                        <input
                                                            required={true}
                                                            type="checkbox"
                                                            value="" />
                                                        {t('dashboard.room_payment.terms')}
                                                    </label>
                                                </div>
                                            </div>

                                            <div className="form-group">
                                                <div className="checkbox">
                                                    <label>
                                                        <input
                                                            onClick={this.handleFacturaChange}
                                                            type="checkbox" />
                                                        <Trans>venta_linea.payment.require_invoice</Trans>
                                                    </label>
                                                </div>
                                            </div>
                                            {this.state.is_factura ? (
                                                <aside className="alert alert-info" role='alert'>
                                                    <Trans>venta_linea.payment.invoice_advise</Trans>
                                                    <a
                                                        href={`mailto:${email_facturacion}`}>
                                                        {" "}{email_facturacion}
                                                    </a>
                                                </aside>
                                            ) : null}
                                        </div>
                                        <div className="col-xs-12">
                                            <div className={this.state.error ? "" : "hidden"}>
                                                <div className="alert alert-warning">
                                                    <i className="glyphicon glyphicon-remove pull-right" onClick={this.props.handleClearError} />
                                                    {this.state.error}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-xs-12">
                                            <div className="form-group">
                                                <button
                                                    className="btn btn-primary btn-full-width"
                                                    disabled={this.state.isPaying}
                                                    type="submit">
                                                    {t('dashboard.room_payment.btn_pay')}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </fieldset>
                        </form>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}

export default compose(
    translate('common'),
    withRouter
)(CardCoworkConatiner);



// WEBPACK FOOTER //
// ./src/store/Cowork/Payment/CardCoworkConatiner.js